module.exports = __webpack_public_path__ + "static/img/img_cxfw.ab8c542.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img_cxfw.png
// module id = ULNV
// module chunks = 1